import React from "react";

import { getColorFromName } from "../utils";


const UserProfile = (props) => {
    const { userNameDetails ,className} = props

    const profileImg = userNameDetails.profileImg

    let userShortName = userNameDetails.firstName?.[0].toUpperCase()
    if(userNameDetails.lastName){
        userShortName += userNameDetails.lastName[0].toUpperCase()
    }

    const initialsColor = profileImg ? 'transparent' : getColorFromName(userNameDetails.firstName)

    return (
        <div className={`profile-btn ${className}`} style={{backgroundColor: initialsColor}}>
            {profileImg ? 
            <img src={profileImg} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}}/>
            : 
            <span>{userShortName}</span>}
        </div>
        
    )
}

export default UserProfile